// Frontend API configuration file

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export default API_BASE_URL;
